const prefixCls = 'web.advert.';

export const localesAdvert = {
  // 页面标题
  [prefixCls + 'title.list']: {
    zh_CN: '广告列表',
    en_GB: 'Advertisement List',
  },
  [prefixCls + 'title.detail']: {
    zh_CN: '广告详情',
    en_GB: 'Advertisement Details',
  },

  // 表格列名
  [prefixCls + 'table.column.title']: {
    zh_CN: '标题',
    en_GB: 'Title',
  },
  [prefixCls + 'table.column.product']: {
    zh_CN: '商品',
    en_GB: 'Product',
  },
  [prefixCls + 'table.column.budget']: {
    zh_CN: '预算 ({currency})',
    en_GB: 'Budget ({currency})',
  },
  [prefixCls + 'table.column.roas']: {
    zh_CN: 'ROAS',
    en_GB: 'ROAS',
  },
  [prefixCls + 'table.column.status']: {
    zh_CN: '状态',
    en_GB: 'Status',
  },
  [prefixCls + 'table.column.startDate']: {
    zh_CN: '开始日期',
    en_GB: 'Start Date',
  },
  [prefixCls + 'table.column.endDate']: {
    zh_CN: '结束日期',
    en_GB: 'End Date',
  },

  // 筛选条件
  [prefixCls + 'filter.searchPlaceholder']: {
    zh_CN: '搜索广告名称',
    en_GB: 'Search advertisement name',
  },
  [prefixCls + 'filter.type']: {
    zh_CN: '类型',
    en_GB: 'Type',
  },

  // 状态文本
  [prefixCls + 'status.live']: {
    zh_CN: '投放中',
    en_GB: 'Live',
  },
  [prefixCls + 'status.paused']: {
    zh_CN: '已暂停',
    en_GB: 'Paused',
  },

  // 类型选项
  [prefixCls + 'type.type1']: {
    zh_CN: '类型一',
    en_GB: 'Type 1',
  },
  [prefixCls + 'type.type2']: {
    zh_CN: '类型二',
    en_GB: 'Type 2',
  },

  // 操作按钮文本
  [prefixCls + 'action.update']: {
    zh_CN: '数据更新',
    en_GB: 'Update Data',
  },

  // 错误信息
  [prefixCls + 'error.fetchFailed']: {
    zh_CN: '获取广告列表失败',
    en_GB: 'Failed to fetch advertisement list',
  },

  // SKU 子表格列名
  [prefixCls + 'sku.column.img']: {
    zh_CN: '图片',
    en_GB: 'Image',
  },
  [prefixCls + 'sku.column.sku']: {
    zh_CN: 'SKU',
    en_GB: 'SKU',
  },
  [prefixCls + 'sku.column.name']: {
    zh_CN: '商品标题',
    en_GB: 'Product Name',
  },
  [prefixCls + 'sku.column.views']: {
    zh_CN: '显示次数',
    en_GB: 'Views',
  },
  [prefixCls + 'sku.column.click']: {
    zh_CN: '点击次数',
    en_GB: 'Clicks',
  },
  [prefixCls + 'sku.column.cpc']: {
    zh_CN: '单次点击费用 ({currency})',
    en_GB: 'CPC ({currency})',
  },
  [prefixCls + 'sku.column.atc']: {
    zh_CN: '加入购物车数',
    en_GB: 'Add to Cart',
  },
  [prefixCls + 'sku.column.orders']: {
    zh_CN: '订单数',
    en_GB: 'Orders',
  },
  [prefixCls + 'sku.column.revenue']: {
    zh_CN: '出单总金额 ({currency})',
    en_GB: 'Revenue ({currency})',
  },
  [prefixCls + 'sku.column.spends']: {
    zh_CN: '广告总花费 ({currency})',
    en_GB: 'Spend ({currency})',
  },
  [prefixCls + 'sku.column.roas']: {
    zh_CN: 'ROAS',
    en_GB: 'ROAS',
  },
};
